import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useBrandsDocumentDetails } from "./Brands.hook";

export const AddEditBrands = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editBrands,
    isLoading: drilldownLoading,
    refetch: refetchBrands,
  } = useBrandsDocumentDetails(query.get("editId") || "");

  const {
    data: editBrandsById,
    isLoading: isLoadingBrands,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  console.log("editBrands", editBrands, editBrandsById);

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchBrands();
    }
  }, [query.get("editId"), query.get("id")]);

  const epcApplicationsFormConfig: FormConfig = {
    initialValues: {
      brandImage: editBrandsById?.payload
        ? [
            {
              uid: "-1",
              name: "brandImage.png",
              status: "done",
              url: editBrandsById?.payload?.brandImage,
            },
          ]
        : editBrands?.brandImage
          ? [
              {
                uid: "-1",
                name: "brandImage.png",
                status: "done",
                url: editBrands?.brandImage,
              },
            ]
          : "",

      name: editBrandsById?.payload ? decodeHTML(editBrandsById?.payload?.name) : decodeHTML(editBrands?.name),
      field_malay_title: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.field_malay_title)
        : decodeHTML(editBrands?.field_malay_title),
      field_mandarin_title: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.field_mandarin_title)
        : decodeHTML(editBrands?.field_mandarin_title),
      field_parent_category: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.field_parent_category)
        : decodeHTML(editBrands?.field_parent_category),

      published: editBrandsById?.payload
        ? decodeHTML(editBrandsById?.payload?.published)
        : decodeHTML(editBrands?.published),
    },
    fields: fields.productBrand,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["brandImage", "bannerImage"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);
          if (res) data[key] = res.response.data;
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else if (Array.isArray(field) && field.length === 0) {
          data[key] = "";
        } else if (!field) {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Product Management",
      subModule: "productBrand",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editBrands?.id || editBrandsById?.payload?.id }),
        ...data,
        // status: true,
        // field_sub_created_at: "2023-11-21T10:01:09",
        // field_sub_updated_at: "2025-11-29T10:01:09"
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingBrands}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Product Brand`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingBrands || drilldownLoading}
        config={epcApplicationsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/brands/browse`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
